import modalInvoiceDetailTmplate from './view/modalInvoiceDetail.html'
import modalInvoiceInfo from './view/modalInvoiceInfo.html'
import utils from 'utils'
class modalUploadListCtrl {
    constructor($scope, $uibModal, $uibModalInstance, items1, httpRequest, logger, sweetalert, $timeout, resultTipService) {
        $scope.uploadType = items1.uploadType
        $scope.addList = items1.removedInvoiceList
        $scope.modalParam = {
            totalMoney: 0,
            uploadListData: [],
        }
        $scope.progress = 0
        $scope.dataSource = items1.dataSource ? items1.dataSource : '1'
        let batchNo = ''
        // 字典字段
        httpRequest.get_dictByTypeArr(['ivat_inv_type', 'deduction_flag', 'verify_status', 'ivat_file_ocr_result']).then((res) => {
            $scope.dictionary = res.data.value
            $scope.dictionary.ivat_inv_type.push({
                enumCode: '-1',
                enumName: '未识别发票类型',
            })
        })
        $scope.getDistinguishTotal = function () {
            //获取识别数
            httpRequest.get_asyncUploadBatchDistStatusList().then(res => {
                if (res.data.success) {
                    $scope.distinguishTotal = res.data.value.length
                }
            })
        }
        if ($scope.uploadType == 5) {
            $scope.distinguishTotal = 0
            //获取批次号
            httpRequest.get_getUploadBatchNo().then(res => {
                if (res.data) {
                    $scope.asyncUploadBatchNo = res.data.value
                }
            })
            $scope.getDistinguishTotal()
        }
        if ($scope.uploadType == '3') {
            const oldSelectedList = items1.selectedInvoiceList
            httpRequest.get_getInvoiceBillList().then((res) => {
                $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.concat(res.data.value)
                if ($scope.addList && $scope.addList.length > 0) {
                    $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.concat($scope.addList)
                }
                // 已存在的默认不显示
                if (oldSelectedList.length) {
                    const selectedInvoiceIds = oldSelectedList.map((v) => v.invoiceId)
                    $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.filter((item) => selectedInvoiceIds.indexOf(item.invoiceId) == -1)
                }
                $scope.selectedUploadRows = []
            })
        }
        if ($scope.uploadType == '4') {
            setTimeout(() => {
                $('#QRCode-auto-focus').on('focusout', () => {
                    setTimeout(() => {
                        $('#QRCode-auto-focus').focus()
                    }, 10)
                })
            })
        }
        // 扫描发票
        let loading
        $scope.scanInvoice = function scanInvoice() {
            loading = window.layer.msg('正在扫描中，请勿有其他操作', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest.post_getScanInitParam({
                host: window.location.origin,
                scanType: '41',
                imgType: '0',
                dataSource: $scope.dataSource,
                scanSource: '2',
                // imgPath:'D:\\38815074+20171226+粤通卡+123.48.pdf'
            }).then((res) => {
                const hostUrl = REAL_URL.split(':')
                const _url = `${`${hostUrl[0]}:${hostUrl[1]}`}:${res.data.value.port}/ScanFP`
                // console.log(_url)
                $.post({
                    url: _url,
                    data: {
                        SID: res.data.value.SID,
                        SIDParam: res.data.value.SIDParam,
                        Config: res.data.value.Config,

                    },
                    cache: false,
                    charset: 'GBK',
                    callbackParameter: 'callback',
                    timeout: 86400000,
                    success(res) {
                        const json = JSON.parse(res)
                        if (json.retcode == '1') {
                            httpRequest.post_scanEndCallBack({
                                responseBody: json.ResponseStr,
                                scanType: '41',
                            }).then((res) => {
                                batchNo = res.data.value.batchNo
                                $scope.getInputBatchInfo(res.data.value.batchNo)
                            })
                        } else {
                            logger.logError('扫描异常！')
                            window.layer.close(loading)
                        }
                    },
                    error(XMLHttpRequest, textStatus) {
                        logger.logError('没有连接扫描仪！')
                        window.layer.close(loading)
                    },
                })
            }, () => {
                window.layer.close(loading)
            })
        }

        // 定时查询扫描
        $scope.getInputBatchInfo = function getInputBatchInfo(batchNo) {
            httpRequest.get_getInputBatchInfo({
                batchNo: batchNo || '',
            }).then((res) => {
                if (res.data.value) {
                    if (res.data.value.batchStatus != 2) {
                        $scope.scanTimeout = $timeout(() => {
                            $scope.getInputBatchInfo(res.data.value.batchNo)
                        }, 5000)
                    } else {
                        if (res.data.value.asyncType == 2) {
                            let inputCount = res.data.value.inputCount
                            $scope.showMsg(inputCount)
                        }
                        httpRequest.get_getIvatBillByBatchNo(res.data.value.batchNo).then((item) => {
                            $timeout.cancel($scope.scanTimeout)
                            window.layer.close(loading)
                            $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.concat(item.data)
                            $scope.caculateMoney() // 重新计算总金额
                        })
                    }
                } else {
                    $scope.scanTimeout = $timeout(() => {
                        $scope.getInputBatchInfo()
                    }, 5000)
                }
            })
        }


        // 扫描枪
        document.onkeydown = (e) => {
            if (e.keyCode == 13 && $scope.uploadType == '4') {
                if (!$scope.qrCodeText) {
                    return logger.logError('没有扫描到数据')
                }
                httpRequest.post_scanningGunSave($scope.qrCodeText).then((res) => {
                    if (res.data.value) {
                        $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.concat(res.data.value)
                        $scope.caculateMoney()
                    } else {
                        logger.logError('二维码格式有误，请扫描发票二维码！')
                    }
                })
                $scope.qrCodeText = ''
            }
        }

        $scope.uploadFiles = function uploadFiles(files, errorFile) {
            if (!files.length || errorFile.length) {
                if (errorFile.length) {
                    logger.logError('上传失败,文件大小不得超过50M')
                }
                return
            }
            const formData = new FormData()
            for (let i = 0; i < files.length; i++) {
                formData.append('file', files[i])
            }
            formData.append('dataSource', $scope.dataSource)
            // 文件上传
            // loading动画
            $scope.showloading = true
            // const importinglayer = layer.msg('玩命上传中，请耐心等待', {
            //     time: 0,
            //     skin: 'layer-loading-self',
            //     icon: 16,
            //     shade: 0.5,
            // })
            httpRequest.post_uploadPdf(formData).then((res) => {
                // 关闭loading
                // layer.close(importinglayer)
                $scope.showloading = false
                if (!res.data.success) {
                    return logger.logError(res.data.message || '上传失败')
                }
                if (res.data.value && res.data.value.asyncType == 2) {
                    let inputCount = res.data.value.inputCount
                    $scope.showMsg(inputCount)
                }
                batchNo = res.data.value.batchNo
                httpRequest.get_getIvatBillByBatchNo(res.data.value.batchNo).then((item) => {
                    $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.concat(item.data)
                    $scope.caculateMoney() // 重新计算总金额
                })
            }, (response) => {
                $scope.showloading = false
                if (response.status > 0) {
                    // 关闭loading
                    layer.close()
                    logger.logError('上传失败 ')
                }
            }, (evt) => {
                // file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total))
            })
        }
        $scope.cancel = () => {
            if ($scope.uploadType == '5' && $scope.showloading) {
                return
            }
            if (($scope.uploadType == '1' || $scope.uploadType == '2' || $scope.uploadType == '5') && $scope.modalParam.uploadListData.length > 0) // 上传或者扫描
            {
                sweetalert.confirm('删除提醒', '关闭弹窗后单据会被删除，确认移除上传单据？').then(() => {
                    if ($scope.uploadType == '5') {
                        $scope.delPic()
                        $uibModalInstance.close()
                    } else {
                        const invoiceList = []
                        $scope.modalParam.uploadListData.forEach((item) => {
                            invoiceList.push(item.invoiceId)
                        })
                        $scope.delInvoiceByidArr(invoiceList, true)
                    }
                }, () => {})
            } else {
                $uibModalInstance.close()
            }
        }
        $scope.ok = () => {
            if ($scope.uploadType == '3') {
                if ($scope.selectedUploadRows.length > 0) {
                    $uibModalInstance.close($scope.selectedUploadRows)
                } else {
                    logger.logError('请选择至少一条票据')
                }
            } else {
                const listLen = $scope.modalParam.uploadListData.length
                let hasUnCheckedInvoice = false
                if (listLen) {
                    for (let i = 0; i < $scope.modalParam.uploadListData.length; i++) {
                        const item = $scope.modalParam.uploadListData[i]
                        if (item.invoiceType == '-1' || item.errorMessage !== '') {
                            // logger.logError("存在未识别发票或者存在识别不通过发票，请手动校验")
                            hasUnCheckedInvoice = true
                            break
                        }
                    }
                    if (hasUnCheckedInvoice) {
                        sweetalert.confirm('保存提醒', '存在未校验通过票据，保存后可在发票收集模块查看，已存在发票将自动删除').then(() => {
                            const invoiceList = []
                            $scope.modalParam.uploadListData.forEach((item) => {
                                invoiceList.push(item.invoiceId)
                            })
                            httpRequest.post_batchDeleteRepeatInvoice(invoiceList).then(() => {
                                const checkedList = $scope.modalParam.uploadListData.filter((x) => x.proofreadStatus == '6')
                                $uibModalInstance.close(checkedList)
                            });
                        }, () => {})
                    } else {
                        $uibModalInstance.close($scope.modalParam.uploadListData)
                    }
                }
            }
        }
        $scope.asyncOk = function () {
            if ($scope.showloading) return
            const listLen = $scope.modalParam.uploadListData.length
            if (listLen) {
                httpRequest.post_asyncUploadStartDist({
                    batchNo: $scope.asyncUploadBatchNo
                }, '上传成功！系统将在后台排队依次处理，可到这里查看识别进度！').then(res => {
                    if (res.data.success) {
                        $scope.modalParam.uploadListData = []
                        $scope.progress = 0
                        //获取识别数
                        $scope.getDistinguishTotal()
                    }
                })
            }
        }
        $scope.showUploadDetail = function (item, index) {
            const modalInvoiceDetail = $uibModal.open({
                template: modalInvoiceDetailTmplate,
                controller: 'modalInvoiceDetailCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail',
                resolve: {
                    items1() {
                        const data = {
                            uploadListData: $scope.modalParam.uploadListData,
                            currentInvoicId: item.invoiceId,
                        }
                        return data
                    },
                },
            })
            modalInvoiceDetail.result.then((data) => {
                if (data) {
                    $scope.modalParam.uploadListData.forEach((v, index) => {
                        if (data.invoiceId == v.invoiceId) {
                            $scope.modalParam.uploadListData[index] = []
                            $scope.modalParam.uploadListData[index] = data
                        }
                        $scope.caculateMoney()
                    })
                }
                $('#QRCode-auto-focus').show()
            })
        }
        $scope.showUploadList = function () {
            $uibModal.open({
                templateUrl: 'modal-distinguish.html',
                controller: ['$scope', '$uibModalInstance', 'logger', 'httpRequest', 'propData', function ($scope, $uibModalInstance, logger, httpRequest, propData) {
                    $scope.distinguishList = []
                    $scope.dictionary = propData.dictionary
                    httpRequest.get_asyncUploadBatchDistStatusList().then(res => {
                        if (res.data.success) {
                            $scope.distinguishList = res.data.value
                        }
                    })
                    $scope.cancel = function () {
                        $uibModalInstance.close()
                    }
                    $scope.delDistinguishItem = function (item) {
                        httpRequest.post_asyncUploadBatchDelBill({
                            batchNo: propData.batchNo,
                            batchId: item.batchId
                        }).then(res => {
                            if (res.data.success) {
                                $scope.distinguishList = $scope.distinguishList.filter((x) => x.batchId !== item.batchId)
                            }
                        })
                    }
                }],
                backdrop: 'static',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-detail',
                resolve: {
                    propData() {
                        return {
                            batchNo: $scope.asyncUploadBatchNo,
                            dictionary: $scope.dictionary
                        }
                    },
                },
            }).result.then(() => {
                $scope.getDistinguishTotal()
            })
        }
        $scope.$watch('selectedUploadRows', (newValue, oldValue) => {
            $scope.modalParam.totalMoney = 0
            if (newValue && newValue.length > 0) {
                newValue.forEach((e) => {
                    $scope.modalParam.totalMoney += +e.adValoremTotal
                })
            }
        }, true)

        $scope.stopclick = function (item, $event) {
            $event.stopPropagation()
        }
        $scope.delInvoiceByidArr = function (invoiceIdArr, close) {
            httpRequest.post_batchDeleteBill(invoiceIdArr).then((res) => {
                if (res.data.success) {
                    logger.logSuccess('移除成功')
                    $scope.caculateMoney()
                    if (close) {
                        $uibModalInstance.close()
                    }
                }
            })
        }
        $scope.delInvoice = function (item, $event) {
            $event.stopPropagation()
            // $scope.modalParam.uploadListData.splice(item, 1)
            $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.filter((x) => x.invoiceId !== item.invoiceId)
            $scope.delInvoiceByidArr([item.invoiceId], false)
        }
        $scope.caculateMoney = function () {
            $scope.modalParam.totalMoney = 0
            $scope.modalParam.uploadListData.forEach((i) => {
                $scope.modalParam.totalMoney += i.adValoremTotal ? +i.adValoremTotal : 0
            })
        }
        $scope.checkSuccess = function (item, $event) {
            $event.stopPropagation()
            $uibModal.open({
                template: modalInvoiceInfo,
                openedClass: 'mod-modal mod-invoice-info',
                animation: true,
                controller: 'modalInvoiceInfo',
                resolve: {
                    invoice() {
                        return {
                            invoiceCode: item.invoiceCode,
                            invoiceNumber: item.invoiceNumber,
                        }
                    },
                },
            })
        }
        //展示提示弹框
        $scope.showMsg = function (inputCount) {
            let html = `<div style='width:100%;text-align:center'>本次新增票据<span style='color:#e4393c'>${inputCount}</span>张！</div>已开启定时识别+查验，系统将在后台依次排队处理这些票据，请过几分钟后再过来查看识别及查验结果！`
            window.layer.open({
                title: '提示',
                content: html,
                btn: ['确定'],
                resize: false,
                closeBtn: 0,
                shadeClose: false,
                move: false,
                yes(index) {
                    window.layer.close(index)
                    $uibModalInstance.close()
                }
            })
        }

        function AsyncUploadFilesHandle() {
            if (!$scope.asyncUploadBatchNo) return
            $scope.idx++
            const formData = new FormData()
            formData.append('file', $scope.asyncFiles[$scope.idx - 1])
            formData.append('batchNo', $scope.asyncUploadBatchNo)
            httpRequest.post_asyncUploadSaveFile(formData).then((res) => {
                if (!res.data.success) {
                    $scope.showloading = false
                    return logger.logError(res.data.message || '上传失败')
                }
                $scope.progress = parseInt($scope.idx / $scope.asyncFiles.length * 100)
                $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.concat(res.data.value)
                if ($scope.idx < $scope.asyncFiles.length) {
                    AsyncUploadFilesHandle()
                } else {
                    if ($scope.modalParam.uploadListData.length) {
                        $scope.progress = 100
                    }
                    $scope.showloading = false
                }
            }).catch(err => {
                $scope.showloading = false
                if ($scope.modalParam.uploadListData.length) {
                    $scope.progress = 100
                }
                logger.logError('上传失败')
            })
        }
        $scope.uploadFilesAsync = function uploadFilesAsync(files, errorFile) {
            if (!files.length || errorFile.length) {
                if (errorFile.length) {
                    logger.logError('上传失败,文件大小不得超过1M')
                }
                return
            }
            $scope.progress = 0
            $scope.idx = 0
            $scope.asyncFiles = files
            $scope.showloading = true
            AsyncUploadFilesHandle()
        }
        $scope.delPic = function delPic(item, ) {
            let params = {
                batchNo: $scope.asyncUploadBatchNo
            }
            if (item) {
                params.batchId = item.batchId
            }
            httpRequest.post_asyncUploadDelFile(params).then(res => {
                if (res.data.success) {
                    logger.logSuccess('移除成功')
                    if (item) {
                        $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.filter((x) => x.batchId !== item.batchId)
                        if ($scope.modalParam.uploadListData.length == 0) {
                            $scope.progress = 0
                        }
                    }
                }
            })
        }
        $scope.check = function (item, $event) {
            $event && $event.stopPropagation()
            const invoiceIds = []
            if (item) {
                invoiceIds.push(item.invoiceId)
            } else {
                $scope.modalParam.uploadListData.forEach(i => {
                    if (i.verifyStatus == 8 || i.verifyStatus == 0) invoiceIds.push(i.invoiceId)
                })
            }
            if (!invoiceIds.length) return logger.logError('无可查验数据')
            utils.loading('发票查验中')
            httpRequest.post_batchVerifyBill(invoiceIds).then(res => {
                utils.loaded()
                if (res.data.value.length) {
                    const params = {
                        sourceCount: invoiceIds.length,
                        errorCount: res.data.value.length,
                        list: res.data.value,
                        title: '查验'
                    }
                    resultTipService.openErrorModal(params, freshData)
                } else {
                    logger.logSuccess(`查验成功${invoiceIds.length}张票据`)
                    freshData()
                }

            })
            // console.log(item)
            // console.log($scope.modalParam.uploadListData)
        }

        function freshData() {
            const invoiceIdList = []
            $scope.modalParam.uploadListData.forEach(i => {
                invoiceIdList.push(i.invoiceId)
            })
            httpRequest.post_getBatchAdjustBillList(invoiceIdList).then((res) => {
                $scope.modalParam.uploadListData = res.data.value
                $scope.caculateMoney() // 重新计算总金额
            })
        }
    }
}

modalUploadListCtrl.$inject = ['$scope', '$uibModal', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'sweetalert', '$timeout', 'resultTipService']
export default modalUploadListCtrl


// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/reimbursement/modalUploadListCtrl.js